import { createSlice } from '@reduxjs/toolkit';
import { fetchCells, fetchCellsBySector } from '../thunks/cell.thunk';

interface ICell {
  id: string;
  name: string;
}

interface CellState {
  allCells: ICell[];
  cellsBySector: ICell[];
  count: number;
  pages: number;
  page: number;
  limit: number;
  loading: boolean;
  error: string | null;
}

const initialState: CellState = {
  allCells: [],
  cellsBySector: [],
  count: 0,
  pages: 0,
  page: 1,
  limit: 10,
  loading: false,
  error: null
};

const cellSlice = createSlice({
  name: 'cells',
  initialState,
  reducers: {
    resetCells: (state) => {
      state.cellsBySector = [];
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCells.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCells.fulfilled, (state, action) => {
        state.loading = false;
        state.allCells = action.payload.items;
        state.count = action.payload.count;
        state.pages = action.payload.pages;
        state.page = action.payload.page;
        state.limit = action.payload.limit;
      })
      .addCase(fetchCells.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch cells';
      })
      .addCase(fetchCellsBySector.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCellsBySector.fulfilled, (state, action) => {
        state.loading = false;
        state.cellsBySector = action.payload;
        state.count = action.payload.count;
        state.pages = action.payload.pages;
        state.page = action.payload.page;
        state.limit = action.payload.limit;
      })
      .addCase(fetchCellsBySector.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || 'Failed to fetch cells by sector';
      });
  }
});

export const { resetCells } = cellSlice.actions;
export const cellReducer = cellSlice.reducer;
